
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 333 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M297.8 490.8c12.2-12.2 12.2-32 0-44.2L101.4 250 297.8 53.3c12.2-12.2 12.2-32 0-44.2s-32-12.2-44.1 0L35.2 227.9c-12.2 12.2-12.2 32 0 44.2l218.5 218.7c12.2 12.3 31.9 12.3 44.1 0z"}})])
          )
        }
      }
    